const sortCompanyNames = (companies: any[]) => {
    return companies.sort((a, b) => {
        if (a["company_name"].startsWith("SME") && !b["company_name"].startsWith("SME")) return -1;
        else if (!a["company_name"].startsWith("SME") && b["company_name"].startsWith("SME")) return 1;
        else return a["company_name"].localeCompare(b["company_name"]);
    });
};

export default sortCompanyNames;
